import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDailyQuestions } from '../data/quizData';
import { useAppContext } from '../context/AppContext';

import Header from "../components/Header";
import Sidebar from "../components/SideBar";
import BottomNav from "../components/BottomNav";
import "../css/mainhome.css";

const InactiveUserQuiz = () => {
  const [dailyQuestions] = useState(() => getDailyQuestions());
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [userAnswers, setUserAnswers] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [showResult, setShowResult] = useState(false);

  const { resetUserContext } = useAppContext();
  const navigate = useNavigate();

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const currentQuestion = dailyQuestions[currentQuestionIndex];

  const handleNext = () => {
    if (!selectedOption) return;

    const newAnswers = [...userAnswers, { questionId: currentQuestion.id, answer: selectedOption }];
    setUserAnswers(newAnswers);
    setSelectedOption('');

    if (currentQuestionIndex < dailyQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setShowResult(true);
    }
  };

  const handleQuizSubmit = async () => {
    if (resetUserContext) {
      resetUserContext();
    }
    navigate('/login-with-mpin', { replace: true });
  };

  const handlePlayAgain = () => {
    setCurrentQuestionIndex(0);
    setUserAnswers([]);
    setSelectedOption('');
    setShowResult(false);
  };

  const renderQuiz = () => (
    <>
      <h2 style={styles.title}>Daily Brain Challenge</h2>
      <p style={styles.subtitle}>Get ready and sharpen your mind with this quick challenge!</p>

      <div style={styles.quizBox}>
        <div style={styles.progress}>
          Question {currentQuestionIndex + 1} of {dailyQuestions.length}
        </div>

        <h3 style={styles.questionText}>{currentQuestion?.question}</h3>

        <div style={styles.optionsContainer}>
          {currentQuestion?.options.map((option, index) => {
            const isSelected = selectedOption === option;
            return (
              <div
                key={index}
                style={{
                  ...styles.optionBlock,
                  backgroundColor: isSelected ? '#d8b042' : '#ffffff',
                  color: isSelected ? '#ffffff' : '#333333',
                  borderColor: isSelected ? '#d8b042' : '#e0e0e0',
                  boxShadow: isSelected ? '0 4px 6px rgba(216, 176, 66, 0.3)' : 'none'
                }}
                onClick={() => handleOptionSelect(option)}
              >
                {option}
              </div>
            )
          })}
        </div>
      </div>

   <button
  onClick={handleNext}
  disabled={!selectedOption}
  onMouseEnter={(e) => {
    e.target.style.transform = "translateY(-3px) scale(1.02)";
    e.target.style.boxShadow = "0 12px 25px rgba(40,167,69,0.5)";
  }}
  onMouseLeave={(e) => {
    e.target.style.transform = "translateY(0px) scale(1)";
    e.target.style.boxShadow = "0 6px 12px rgba(40,167,69,0.3)";
  }}
  style={{
    ...styles.button,
    background: 'linear-gradient(135deg, #6ee7b7, #28a745)', // premium green gradient
    color: '#ffffff',
    opacity: !selectedOption ? 0.5 : 1,
    cursor: !selectedOption ? 'not-allowed' : 'pointer',
    boxShadow: '0 6px 12px rgba(40,167,69,0.3)',
    borderRadius: '30px', // pill shape
    letterSpacing: '1.5px',
    fontSize: '17px',
  }}
>
  {currentQuestionIndex === dailyQuestions.length - 1 ? '✨ Show Results' : '👉 Next Question'}
</button>
    </>
  );

  // ✅ CLEAN RESULT (NO QUESTION/ANSWER LIST)
  const renderResult = () => {
    let score = 0;
    userAnswers.forEach(ans => {
      const q = dailyQuestions.find(qItem => qItem.id === ans.questionId);
      if (q && q.correctAnswer === ans.answer) {
        score++;
      }
    });

    return (
      <div>
        <h2 style={{ ...styles.title, color: '#d8b042', fontSize: '26px' }}>
          Today's Results
        </h2>

        <p style={{ fontSize: '18px', fontWeight: 'bold', margin: '15px 0', color: '#333' }}>
          Your Score: {score} out of {dailyQuestions.length}
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button
            onClick={handlePlayAgain}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 10px 20px rgba(0,128,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0px)";
              e.target.style.boxShadow = "0 6px 12px rgba(0,128,0,0.2)";
            }}
            style={{
              ...styles.button,
              background: 'linear-gradient(135deg, #28a745, #218838)', // green gradient
              color: '#ffffff',
              boxShadow: '0 6px 12px rgba(0,128,0,0.2)'
            }}
          >
            Play Again
          </button>

          <button
            onClick={handleQuizSubmit}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 10px 20px rgba(216,176,66,0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0px)";
              e.target.style.boxShadow = "0 6px 12px rgba(216,176,66,0.3)";
            }}
            style={{
              ...styles.button,
              background: 'linear-gradient(135deg, #fff3cd, #ffe08a)', // light yellow
              color: '#8a6d00',
              boxShadow: '0 6px 12px rgba(216,176,66,0.3)'
            }}
          >
            Thanks for Playing! 
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="mainhome-screen-wrapper" style={{ position: "relative" }}>
      <Header
        onMenuClick={() => setSidebarOpen(true)}
        isAccountActive={false}
      />

      {isSidebarOpen && (
        <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      )}

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          scrollbarWidth: "none",
          paddingBottom: 90,
          paddingTop: 20,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}
      >
        <div style={styles.card}>
          {showResult ? renderResult() : renderQuiz()}
        </div>
      </div>

      <BottomNav active="Home" />
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: '#f5f5f5',
    padding: '24px',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
    width: '90%',
    maxWidth: '500px',
    textAlign: 'center',
    margin: '0 auto',
    marginTop: '20px',
    border: '1px solid #e0e0e0'
  },
  title: {
    margin: '0 0 8px',
    color: '#000',
    fontWeight: '700',
    fontSize: '22px'
  },
  subtitle: {
    color: '#666',
    marginBottom: '24px',
    fontSize: '14px'
  },
  quizBox: {
    textAlign: 'left',
    marginBottom: '30px'
  },
  progress: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#d8b042',
    marginBottom: '12px',
    textTransform: 'uppercase',
    letterSpacing: '1px'
  },
  questionText: {
    fontSize: '18px',
    color: '#222',
    marginBottom: '20px',
    fontWeight: '600',
    lineHeight: '1.4'
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  optionBlock: {
    padding: '14px 18px',
    borderRadius: '12px',
    border: '2px solid #e0e0e0',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontSize: '16px',
    fontWeight: '500',
  },
  button: {
    width: '100%',
    padding: '16px',
    border: 'none',
    borderRadius: '14px',
    background: 'linear-gradient(135deg, #000000, #2c2c2c)',
    color: '#d8b042',
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '1px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 6px 15px rgba(0,0,0,0.25)',
  },
};

export default InactiveUserQuiz;
